import { render, staticRenderFns } from "./CustomFieldsContainerComponent.vue?vue&type=template&id=1fa425e3&scoped=true&lang=pug"
import script from "./CustomFieldsContainerComponent.vue?vue&type=script&lang=ts"
export * from "./CustomFieldsContainerComponent.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldsContainerComponent.vue?vue&type=style&index=0&id=1fa425e3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa425e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fa425e3')) {
      api.createRecord('1fa425e3', component.options)
    } else {
      api.reload('1fa425e3', component.options)
    }
    module.hot.accept("./CustomFieldsContainerComponent.vue?vue&type=template&id=1fa425e3&scoped=true&lang=pug", function () {
      api.rerender('1fa425e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customFields/CustomFieldsContainer/CustomFieldsContainerComponent.vue"
export default component.exports